module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/small_gold_light.7517dea0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/small_gold_light.png
// module id = 2871
// module chunks = 11